// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import element from './element/index'
import './permission'
// import '@/mock/index'
import '../static/css/style.css'
import './assets/iconfont/iconfont.css'

Vue.config.productionTip = false;
Vue.use(element);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  /*引入APP主文件的方法一*/
  render: h => h(App)
  /*引入主文件的方法二*/
  /*components: { App },
  template: '<App/>'*/
});



// WEBPACK FOOTER //
// ./src/main.js